module.exports = require("once");